<template>
	<div>
		<div v-if="!dialogVisible">
			<div style="font-size: 16px; margin-top: 10px; margin-left: 40px; font-weight: 600;">工资拆分现金明细表</div>
			<el-row style="margin-top: 9px;">
				<el-row style="margin: 0px 2%; margin-top: 10px;">
					<el-col :span="6" style="margin-top: 10px;width: 150px;">
						<el-radio v-model="condition.distinguish" label="1">月份</el-radio>
						<el-radio v-model="condition.distinguish" label="2">日期</el-radio>
					</el-col>

					<el-col :span="4" v-if="this.condition.distinguish === '1'">
						<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
							value-format="yyyy-MM" style="margin-left: 10px;width: 200px;">
						</el-date-picker>
					</el-col>

					<el-col :span="4" v-if="this.condition.distinguish === '2'">
						<el-date-picker v-model="condition.year_date" type="date" placeholder="请选择"
							value-format="yyyy-MM-dd" style="margin-left: 10px;width: 200px;">
						</el-date-picker>
					</el-col>

					<el-col :span="4">
						<span>架构 </span>
						<el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:200px"
							collapse-tags :props="props"></el-cascader>
					</el-col>

					<el-col :span="4">
						<span>姓名 </span>
						<el-input v-model="condition.cardholder_name" style="margin-left:10px;width: 200px;" clearable
							placeholder="请输入姓名"></el-input>
					</el-col>

					<el-col :span="5">
						<span>身份证号 </span>
						<el-input v-model="condition.id_card" style="margin-left:10px;width: 200px;" clearable
							placeholder="请输入身份证号"></el-input>
					</el-col>

					<el-col :span="5" style="margin-top: 10px;width: 200px;">
						<el-radio v-model="condition.distribution_status" label="0">未发放</el-radio>
						<el-radio v-model="condition.distribution_status" label="1">已发放</el-radio>
					</el-col>
					<el-col :span="6" style="display:flex;float: right;margin: 15px 0 -15px 0;">
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="Find"> 查询
						</el-button>

						<download-excel class="export-excel-wrapper" :fields="download_excel" name="工资拆分现金明细表"
							:fetch="ExportForm" style="">
							<el-button
								style="width: 85px; margin-left:10px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
								导出</el-button>
						</download-excel>

						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;margin-left:10px; "
							@click="ok(null)"> <span style="margin-left: -5px;">发放成功</span>
						</el-button>

						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="nook(null)"> <span style="margin-left: -5px;">发放失败</span>
						</el-button>
					</el-col>
				</el-row>

				<el-row style="margin: 0px 2%; margin-top: 20px;">
					<el-row style="margin-top: 10px;">
						<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" :border="true"
							:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" height="520"
							tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
							<el-table-column type="selection" align="center" width="55">
							</el-table-column>
							<el-table-column align="center" label="序号" width="60">
								<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
							</el-table-column>
							<el-table-column prop="cardholder_name" align="center" label="姓名" width="100">
							</el-table-column>
							<el-table-column prop="entry_name" align="center" label="项目名称" width="350">
							</el-table-column>
							<el-table-column prop="years_date" align="center" label="归属月"></el-table-column>
							<el-table-column prop="receiving_method" align="center" label="领取方式" width="100">
							</el-table-column>
							<el-table-column prop="partner_abbreviation" align="center" label="账户"></el-table-column>
							<el-table-column prop="after_tax_paid_salary" align="center" label="金额"></el-table-column>
							<el-table-column prop="" align="center" label="工资制作负责人"></el-table-column>
							<el-table-column prop="actual_receipt" align="center" label="实际领取">
								<template slot-scope="scope">
									<el-input v-show="scope.row.show" v-model="scope.row.actual_receipt" size="mini"
										type="number"></el-input>
									<span v-show="!scope.row.show">{{ scope.row.actual_receipt }}</span>
								</template>
							</el-table-column>
							<el-table-column prop="remarks" align="center" label="备注">
								<template slot-scope="scope">
									<el-input v-show="scope.row.show" v-model="scope.row.remarks" size="mini">
									</el-input>
									<span v-show="!scope.row.show">{{ scope.row.remarks }}</span>
								</template>
							</el-table-column>
							<el-table-column align="center" label="操作" width="150">
								<template slot-scope="scope" >
									<button v-show="scope.row.distribution_status != 1"
										style="width: 50px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;border-radius: 5px"
										@click="edit(scope.$index, scope.row)">编辑</button>
									<button v-show="scope.row.distribution_status != 1"
										style="width: 50px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;border-radius: 5px"
										@click="save(scope.$index, scope.row)">保存</button>
									<!-- <img src="../../../assets/编辑.png" @click="Edit(scope.row)" /> -->
									<span v-show="scope.row.distribution_status == 1">{{ scope.row.distribution_time }}</span>
								</template>
							</el-table-column>
						</el-table>
					</el-row>
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</el-row>
			</el-row>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	components: {},
	data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
			return organizeList.data;
		};
		return {
			//列表相关
			page_num: 1,
			page_size: 10,
			total: 0,
			tableData: [],
			//组织架构数据
			organizeList: [],
			//复选框ids
			ids: [],

			//条件
			condition: {
				years_date: this.$globals.getNowTimes(),
				year_date: this.$globals.getNowTime(),
				distribution_status: '0',
				distinguish: '1',
				organize_name: '',
				organize_ids: [],
				cardholder_name: '',
				id_card: '',
			},

			//详情
			from: {},
			download_excel: {
				"姓名": "cardholder_name",
				"身份证号": {
					field: "id_card",
					callback: value => {
						return "&nbsp;" + value;
					}
				},
				"项目名称": "entry_name",
				"架构名称": "organize_name",
				"金额": "after_tax_paid_salary",
				"领取方式": "receiving_method",
				"账户": "partner_abbreviation",
				"联系电话": "telephone_number",
				"发放时间": "release_date",
				"入职日期": "induction_date",
			},

			//级联下拉配置
			props: {
				lazy: true,
				async lazyLoad(node, resolve) {
					if (node.level === 0) {
						return resolve(await organizeFind('', 'group'));
					} else {
						resolve(await organizeFind(node.data.id, ''));
					}
				},
				value: "id",
				label: "organize_name",
				children: "organizeList",
				checkStrictly: true,
				multiple: true,
			},
			//操作栏状态
			operation_status: false,
		};
	},
	methods: {
		// 全选
		handleSelectionChange(e) {
			this.ids = [];
			e.forEach(item => {
				this.ids.push(item.id);
			});
		},
		//成功
		async ok(e) {
			var ids;
			if (e === null || e === "" || e === undefined) {
				ids = this.ids;
			} else {
				ids = [e];
			}

			var url = "/Salary/updateDistributionStatus";
			var record = {
				ids: ids,
				distribution_status: '1'
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === "-2000") {
				this.$message.error("服务器未响应！请稍后重试");
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.Find();
				} else {
					this.$message.warning(data);
				}
			}
			this.Find();
		},

		//失败
		async nook(e) {
			var ids;
			if (e === null || e === "" || e === undefined) {
				ids = this.ids;
			} else {
				ids = [e];
			}

			var url = "/Salary/updateDistributionStatus";
			var record = {
				ids: ids,
				distribution_status: '2'
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === "-2000") {
				this.$message.error("服务器未响应！请稍后重试");
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.Find();
				} else {
					this.$message.warning(data);
				}
			}
			this.Find();
		},

		//点击编辑
		edit(index, row) {
			row.show = true;
			this.$set(this.$refs.multipleTable.tableData, index, row);

		},
		//点击保存
		save(index, row) {
			var url = '/Salary/updateWagesPayable';
			var record = {
				id: row.id,
				actual_receipt: row.actual_receipt,//实际领取
				remarks: row.remarks,//备注
			};
			var data = this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				this.$message.success('修改成功！');
				row.show = false;
				this.$set(this.$refs.multipleTable.tableData, index, row);
			}

		},
		//查询
		Find() {
			var temporary = [];
			this.condition.organize_ids.forEach(item => {
				temporary.push(item[item.length - 1]);
			})
			var organize_ids = "";
			temporary.forEach(item => {
				organize_ids += item + ",";
			})
			const url = this.$globals.http + "/Salary/selectWageSplitting";
			axios.post(url, {
				page_num: this.page_num,
				page_size: this.page_size,
				years_date: this.condition.distinguish === '1' ? this.condition.years_date + '-01' : this
					.condition.year_date,
				distribution_status: this.condition.distribution_status,
				distinguish: this.condition.distinguish,
				organize_name: organize_ids.substring(0, organize_ids.length - 1),
				cardholder_name: this.condition.cardholder_name,
				id_card: this.condition.id_card,
			}).then((response) => {
				var code = response.data.code;
				var data = response.data.data;

				if (code === '200') {
					this.tableData = data.list;
					this.total = data.total;

				} else {
					this.$message.warning("请求失败！请稍后重试");
				}
			}).catch((error) => {
				console.log(error)
				this.$message.error("服务器未响应！请稍后重试");
			})
		},
		//导表
		async ExportForm() {
			var temporary = [];
			this.condition.organize_ids.forEach(item => {
				temporary.push(item[item.length - 1]);
			})
			var organize_ids = "";
			temporary.forEach(item => {
				organize_ids += item + ",";
			})
			var url = '/Salary/selectWageSplittings';
			var record = {
				years_date: this.condition.distinguish === '1' ? this.condition.years_date + '-01' : this
					.condition.year_date,
				distribution_status: this.condition.distribution_status,
				distinguish: this.condition.distinguish,
				organize_name: organize_ids.substring(0, organize_ids.length - 1),
				cardholder_name: this.condition.cardholder_name,
				id_card: this.condition.id_card,
			};
			var data = await this.$globals.AxiosPost(url, record);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					if (data.length > 0) {
						this.$message.success("导表成功！文件下载中！");
						return data;
					} else {
						this.$message.success("没有可以导出的数据！");
						return null;
					}

				}
			}
		},
		//分页
		handleCurrentChange(val) {
			this.page_num = val
			this.Find();
		},

	},
	async created() {
		this.Find()
	}
}
</script>

<style scoped="scoped">
>>>.el-button:hover {
	background-color: #FFFFFF;
}

>>>.el-button:focus {
	background-color: #FFFFFF;
}

>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #006E4B;
}

>>>.el-input__inner:focus {
	border-color: #006E4B;
}

>>>.el-select .el-input.is-focus .el-input__inner {
	border-color: #006E4B;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #006E4B;
	border-color: #006E4B;
}

>>>.el-checkbox__inner:hover {
	border-color: #006E4B;
}
</style>



// WEBPACK FOOTER //
// GzcfxjMx.vue?b3d77630